"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAuctionHistoryByAddress = exports.fetchAuction = exports.fetchAuctionBid = exports.fetchAuctionsByShop = void 0;
const qs_1 = __importDefault(require("qs"));
const Logger = 'CandyShopSDK/AuctionAPI';
function fetchAuctionsByShop(axiosInstance, shopId, queryDto = {}) {
    const { offset, limit = 10, status, walletAddress } = queryDto;
    console.log(`${Logger}: fetching Auctions By ShopId=`, shopId);
    let queryObj = {};
    if (offset !== undefined) {
        queryObj = { offset, limit };
    }
    if (status === null || status === void 0 ? void 0 : status.length) {
        queryObj = { ...queryObj, status };
    }
    if (walletAddress) {
        queryObj = { ...queryObj, walletAddress };
    }
    const queryString = qs_1.default.stringify(queryObj, { indices: false });
    return axiosInstance.get(`/auction/${shopId}?${queryString}`).then((response) => response.data);
}
exports.fetchAuctionsByShop = fetchAuctionsByShop;
function fetchAuctionBid(axiosInstance, auctionAddress, walletAddress) {
    console.log(`${Logger}: fetching Auction bid by auctionAddress=${auctionAddress}, walletAddress=${walletAddress}`);
    return axiosInstance.get(`/auction/${auctionAddress}/wallet/${walletAddress}`).then((res) => res.data);
}
exports.fetchAuctionBid = fetchAuctionBid;
function fetchAuction(axiosInstance, auctionAddress) {
    console.log(`${Logger}: fetching Auction detail, auctionAddress=${auctionAddress}`);
    return axiosInstance.get(`/auction/${auctionAddress}`).then((res) => res.data);
}
exports.fetchAuction = fetchAuction;
function fetchAuctionHistoryByAddress(axiosInstance, auctionAddress) {
    console.log(`${Logger}: fetching Auction bid history by auctionAddress=`, auctionAddress);
    return axiosInstance.get(`/auction/history/${auctionAddress}`).then((res) => res.data);
}
exports.fetchAuctionHistoryByAddress = fetchAuctionHistoryByAddress;
